import { render, staticRenderFns } from "./cebian.vue?vue&type=template&id=201a36e9&scoped=true&"
import script from "./cebian.vue?vue&type=script&lang=js&"
export * from "./cebian.vue?vue&type=script&lang=js&"
import style0 from "./cebian.vue?vue&type=style&index=0&id=201a36e9&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a36e9",
  null
  
)

export default component.exports